import {Component, Input, ChangeDetectionStrategy} from '@angular/core';


@Component({
    selector: 'app-character-counter',
    templateUrl: './character-counter.component.html',
    styleUrls: ['./character-counter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class CharacterCounterComponent {

  @Input() maxChars: number = 500;
  @Input() maxCharsWarning: number = 500;
  @Input() charSequenceLength: number = 0;
  @Input() isArdPopnacht: boolean = false;

  @Input() position: 'inside' | 'below' = 'inside';

  constructor() {
  }
}
